const EVENTS = {
  CART_RENDER: 'cartRender',
  CHECKOUT_RENDER: 'checkoutRender',
  SELECTED_PRODUCTS: 'SelectedProducts',
  QUANTITY_CHANGED: 'QuantityChanged',
  CART_CHANGE_AMOUNT: 'CartChangeAmount',
  PRODUCT_REMOVED: 'ProductRemoved',
  PRODUCT_REMOVED_DELIVERY: 'ProductRemovedDelivery',
  CART_DELETE_PRODUCTS: 'CartDeleteProducts',
  PRODUCT_RESTORE: 'ProductRestore',
  CLEAR_DELETED_PRODUCTS: 'ClearDeletedProducts',
  PRODUCT_MAX_QUANTITY: 'ProductMaxQuantity',
  PRODUCT_DELIVERY_SUMMARY: 'ProductDeliverySummary',
  CART_FAVORITE_STATUS: 'ProductFavoriteStatus',
  CART_WIDGET_SHOWN: 'CartWidgetShown'
};

export default EVENTS;
